import type { AppProps, AppContext } from 'next/app';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Layout, ILayoutProps } from '@/components/layout';
import Head from 'next/head';
import axios from 'axios';

import App from 'next/app';
import './global.scss';
import { IndexContextProvider } from '@/stores';
import { IntlProvider } from 'next-intl';
axios.defaults.withCredentials = true;


export interface IComponentProps {
  lang?: string;
}

const MyApp = (_data: AppProps & ILayoutProps & IComponentProps & any): JSX.Element => {
  const {
    Component, navbarData, footerData, pageProps,
    locale, messages
  } = _data;

  useEffect(() => {
    const loadFont = async () => {
      //@ts-ignore
      await import('@/public/font/font.css');
    };
    loadFont();
  }, [])

  return (
    <div>
      <Head>
        <title>IPB国际粉体、散料、流体加工展览会</title>
        {/* <meta name='thumbnail' content='https://www.organic-festa.com/image/logo.png' /> */}
        <meta name="keywords" content="IPB国际粉体、散料、流体加工展览会" />
        <meta name="description" content="IPB国际粉体、散料、流体加工展览会" />
        <link rel="shortcut icon" type="image/x-icon" href="/image/favicon.png" />
        <meta name="baidu-site-verification" content="codeva-woSxZfgccH" />
        <script
          defer
          dangerouslySetInnerHTML={{
            __html: `
            var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?9b7475c8f53ba3c89d5c6afc1eb987b5";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
    `,
          }}
        />
      </Head>
      <IntlProvider locale={locale} messages={messages}>
        <IndexContextProvider>
          <Layout
            navbarData={navbarData}
            footerData={footerData}
          >
            <Component {...pageProps} />
          </Layout>
        </IndexContextProvider>
      </IntlProvider>
    </div>
  );
};

MyApp.getInitialProps = async (ctx: any) => {
  const locale = ctx?.ctx?.locale || 'cn';

  const messages = await import(`../locales/${locale}/common.json`);
  return { ...(await App.getInitialProps(ctx)), locale, messages: messages.default };
};

export default MyApp;
